import * as types from '../constants'

const initialState = {
  faq: [],
  faqQuestion: {},
  simulatorLoading: false,
  simulatorActived: false,
  simulatorResult: {},
  cities: [],
  region: '',
  search: {
    city: '',
    neighborhood: '',
  },
  regionsByCitySimulator: [],
  regionsByCitySimple: [],
  branchesByCoords: [],
  branchesByRegion: [],
  branchesMapSuggest: false,
  regionBranches: [],
  shBranchId: '',
  lastProductCity: '',
  regions: [],
  phone: '',
  contactModals: {
    modalOpened: false,
    modalOptions: undefined,
    modalWhats: undefined,
    modalCall: undefined,
    modalChat: undefined,
    modalEmail: undefined,
    modalObra: undefined,
  },
  optionsModals: {},
  highlightModal: {},
  toursModal: {
    opened: false,
  },
  galleryModal: {
    opened: false,
  },
  indicate: {
    errorMessage:'',
  },
  policies: {
    privacy: [],
    cookies: [],
  },
  showNewsletter: true,
  searchItems: {},
}

const shared = (state = initialState, action) => {
  switch (action.type) {

    case types.SIMULATOR_LOADING:
      return { ...state, simulatorLoading: action.payload }

    case types.UPDATE_SIMULATOR_ACTIVED:
      return { ...state, simulatorActived: action.payload }

    case types.UPDATE_SIMULATOR_RESULT:
      return { ...state, simulatorResult: action.payload }

    case types.UPDATE_FAQ:
      return { ...state, faq: action.payload }

    case types.UPDATE_FAQ_QUESTION:
      return { ...state, faqQuestion: action.payload }

    case types.UPDATE_CITIES:
      return { ...state, cities: action.payload }

    case types.UPDATE_POLICIES:
      return { ...state, policies: action.payload }

    case types.UPDATE_REGION:
      return { ...state, region: action.payload }

    case types.UPDATE_SEARCH_IDS:
      return { ...state, search: action.payload }

    case types.UPDATE_REGIONS_BY_CITY_SIMULATOR:
      return { ...state, regionsByCitySimulator: action.payload }

    case types.UPDATE_REGIONS_BY_CITY_SIMPLE:
      return { ...state, regionsByCitySimple: action.payload }

    case types.UPDATE_BRANCHES_BY_COORDS:
      return { ...state, branchesByCoords: action.payload }

    case types.UPDATE_BRANCHES_MAP_SUGGEST:
      return { ...state, branchesMapSuggest: action.payload }

    case types.UPDATE_BRANCHES_BY_REGION:
      return { ...state, branchesByRegion: action.payload }

    case types.UPDATE_PHONE:
      return { ...state, phone: action.payload }

    case types.UPDATE_REGIONS:
      return { ...state, regions: action.payload }

    case types.CONTACT_MODALS:
      return { ...state, contactModals: action.contactModals }

    case types.CONTACT_MODALS_OPTIONS:
      return { ...state, optionsModals: action.payload }

    case types.CONTACT_MODALS_HIGHLIGHT:
      return { ...state, highlightModal: action.payload }

    case types.UPDATE_MODAL_TOURS:
      return { ...state, toursModal: action.payload }

    case types.UPDATE_MODAL_GALLERY:
      return { ...state, galleryModal: action.payload }

    case types.INDICATE_FAIL_MESSAGE:
      return { ...state, indicate: { errorMessage: action.payload } }

    case types.UPDATE_REGION_BRANCHES:
      return { ...state, regionBranches: action.payload }

    case types.UPDATE_LAST_PRODUCT_CITY:
      return { ...state, lastProductCity: action.payload }

    case types.UPDATE_SHOW_NEWSLETTER:
      return { ...state, showNewsletter: action.payload }

    case types.UPDATE_SEARCH_ITEMS:
      return { ...state, searchItems: action.payload }

    default:
      return state
  }
}

export default shared



// WEBPACK FOOTER //
// ./src/store/shared/reducer.js